require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL_PADDING_HORIZONTAL = exports.LABEL_WIGGLE_X_OFFSET = exports.MINIMIZED_LABEL_FONT_SIZE = exports.MAXIMIZED_LABEL_FONT_SIZE = void 0;
var MAXIMIZED_LABEL_FONT_SIZE = 16;
exports.MAXIMIZED_LABEL_FONT_SIZE = MAXIMIZED_LABEL_FONT_SIZE;
var MINIMIZED_LABEL_FONT_SIZE = 12;
exports.MINIMIZED_LABEL_FONT_SIZE = MINIMIZED_LABEL_FONT_SIZE;
var LABEL_WIGGLE_X_OFFSET = 4;
exports.LABEL_WIGGLE_X_OFFSET = LABEL_WIGGLE_X_OFFSET;
var LABEL_PADDING_HORIZONTAL = 12;
exports.LABEL_PADDING_HORIZONTAL = LABEL_PADDING_HORIZONTAL;